export default __webpack_public_path__ + "static/media/popup.30d5f0f9.svg";